<template>
  <div class="company-info pd-l-20 pd-r-20 pd-t-40" style="overflow-x: scroll">
    <SpForm ref="comInfoForm" v-model="companyDetail" @submit="submit">
      <div class="flex-jc-end">
        <SpButton class="mg-r-20" circle-radius="5" type="back" :width="240" :height="70">
          <span class="font-bold font18">{{ $l('back') }}</span>
        </SpButton>
        <SpButton type="primary" circle="5" html-type="submit" :label="$L('submit')" :width="240" :height="70">
          <span class="font-bold font18">{{ $l('Submit') }}</span>
        </SpButton>
      </div>
      <div class="flex-jc-bt main">
        <div class="flex-58 left left-side text-left" style="min-width: 900px">
          <sp-card class="card cus-card-pd" custom-class="sp-color-bg-4">
            <div class="flex-jc-start pd-l-10 pd-t-20">
              <div class="flex-40">
                <div class="label-content">
                  <p v-required class="fw-bold italic label">{{ $l('LinkedOCNode') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <!--                    {{ !route.query?.nodeId || linkedOCNodes.length > 0 }} -->
                    <SpSelect v-if="!route.query?.nodeId && linkedOCNodes.length > 0" v-model="companyDetail.nodeId" class="flex-1" required name="nodeId" type="warn" :disabled="!!nodeId" @after-select="nodeChange">
                      <SpSelectOption v-for="node in linkedOCNodes" :key="node.id" :value="node.id" :label="node.title" type="primary" />
                    </SpSelect>
                    <SpInput v-else v-model="companyDetail.node.title"
                             :custom-selection-disable="false" :disabled="nodeEditDisabled" class="flex-1"
                             name="node.title" :type="nodeEditDisabled ? 'gray': 'warn'"
                             @blur="updateNode" @focus="recordTitle(companyDetail.node.title)" />
                    <div class="icon-panel"><span v-if="companyDetail.node?.id" class="icon-edit-1 iconfont" @click="nodeEditDisabled = !nodeEditDisabled" /></div>
                  </div>
                </div>
                <div class="label-content mg-t-10">
                  <p v-required class="fw-bold italic label">{{ $l('CompanyName') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <div class="flex-1">
                      <SpInput v-model="companyDetail.name" placeholder="English" height="70" required name="name" type="warn" />
                      <SpInput v-model="companyDetail.nativeName" placeholder="Native Language "
                               style="margin-top: 2px" height="70" name="nativeName" type="warn2" />
                    </div>

                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
              <div class="flex-60">
                <div class="flex-jc-start">
                  <div class="flex-1" />
                  <div style="width: 200px">
                    <p class="fw-bold italic sp-color-1" style="margin: 0;">{{ $l('AboutCompanyName') }}</p>
                    <sp-radio-group v-model="companyDetail.regLevel" name="regLevel">
                      <sp-radio :disabled="companyDetail.nodeType === 2" class="comp-radio" :value="`${ENTERPRISE_REG_LEVEL_REG}`">
                        <p>{{ $l("RegisteredName") }}</p>
                      </sp-radio>
                      <sp-radio :disabled="companyDetail.nodeType === 2" class="comp-radio" :value="`${ENTERPRISE_REG_LEVEL_VIRTUAL}`">
                        <p>{{ $l("VirtualName") }}</p>
                      </sp-radio>
                    </sp-radio-group>
                  </div>
                </div>

                <div class="label-content mg-t-20">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="flex-1 pd-r-10 text-right">
                      <span v-required class="fw-bold italic pd-r-10">{{ $l('CodeName') }}</span>
                    </div>
                    <div class="flex-1">
                      <!--                      <SpInput v-model="companyDetail.codeName" disabled placeholder="English" row="3" required name="codeName" type="gray" /> -->

                      <SpInput v-if="!!companyDetail.id" :disabled="codeNameDisabled" required :validate-reg="/[A-Z]{15}$/" name="codeName" :type="codeNameDisabled ? 'gray': 'warn'" />
                      <SpInput v-else v-model="codeName" :disabled="codeNameDisabled" required :validate-reg="/[A-Z]{15}$/" name="codeName" :type="codeNameDisabled ? 'gray': 'warn'" />
                    </div>
                    <div class="icon-panel"><span v-if="!companyDetail.id" class="icon-edit-1 iconfont" @click="codeNameDisabled = !codeNameDisabled" /></div>
                  </div>
                </div>

                <div class="label-content">
                  <p v-required class="fw-bold italic label" style="padding-left: 75px">{{ $l('Register Country or SAR and City:') }}</p>
                  <!--                  <p v-else class="fw-bold italic label" style="padding-left: 85px">{{ $l('Register Country or SAR and City:') }}</p> -->
                  <div class="content flex-al-center flex-jc-start">
                    <div class="flex-1 pd-r-10 text-right">
                      <div class="flex-al-center flex-jc-start">
                        <div class="flex-1">
                          <SpSelect v-model="companyDetail.regCountryId"
                                    required
                                    height="42" name="regCountryId" type="warn"
                                    @after-select="searchCity">
                            <SpSelectOption v-for="item in countrys" :key="item.id" :label="item.name" :value="item.id" />
                          </SpSelect>
                        </div>
                        <div style="width: 30px">
                          —
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <SpSelect v-model="companyDetail.regCityId" name="regCityId"
                                :disabled="!companyDetail.regCountryId"
                                required
                                type="warn" height="42" @search="toSearchCity">
                        <SpSelectOption v-for="item in citys" :key="item.id" :label="`${item.name} [${item?.stateCode}]`" :value="item.id" />
                      </SpSelect>
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>
                <div class="label-content" style="margin-top: -14px">
                  <div class="content flex-al-center flex-jc-start">
                    <div class="flex-1 pd-r-10 text-right">
                      <div class="flex-al-center flex-jc-start">
                        <div class="flex-1">
                          {{ companyDetail.regCountryCode }}
                        </div>
                        <div style="width: 30px">
                          —
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <SpInput v-model="companyDetail.regCityCode" class="size-8" width="44" height="24" row="3" name="regCityCode" type="warn2" />
                    </div>
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
            </div>
            <div class="gray-bar" />
            <div class="pd-b-20 pd-l-10">
              <p v-required class="fw-bold italic sp-color-1">{{ $l('ShiplusAccessIdentity') }}</p>
              <div class="access-identity">
                <div class="text-center top">
                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Port") }}</p>
                  </sp-radio>
                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Survey Company") }}</p>
                  </sp-radio>
                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Insuror") }}</p>
                  </sp-radio>

                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Stevedore Company") }}</p>
                  </sp-radio>
                  <sp-radio class="comp-radio" disabled>
                    <p>{{ $l("IT/Softwaer") }}</p>
                  </sp-radio>
                </div>
                <div class="content flex-al-center flex-jc-start">
                  <div class="content-left text-right">
                    <sp-radio class="comp-radio mg-r-20" label-position="left" disabled>
                      <p>{{ $l("Forwarder") }}</p>
                    </sp-radio>
                    <sp-radio class="comp-radio mg-r-20" label-position="left" disabled>
                      <p>{{ $l("Logistics") }}</p>
                    </sp-radio>
                    <sp-radio class="comp-radio mg-r-20" label-position="left" disabled>
                      <p>{{ $l("Bank for L/C ") }}</p>
                    </sp-radio>
                  </div>
                  <div class="flex-1">
                    <sp-radio-group v-model="companyDetail.identity" required class="cus-disabled-choose" name="identity" :cancelable="false">
                      <div class="flex-al-center flex-jc-center">
                        <div class="flex-32">
                          <div class="three-dimensional">
                            <div class="top" />
                            <div class="flex-al-center">
                              <div class="left" />
                              <div class="dimensional-content flex-1">
                                <sp-radio :value="IDENTITY_CARGO" class="comp-radio" style="margin-top: 0">
                                  <p class="radio-label sp-color-4">{{ $l("Charterers") }}</p>
                                </sp-radio>
                                <p class="dimensional-content-p">Based on the background of  traders,manufaters and mills.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-36">
                          <div>
                            <div class="center-td-panel flex-al-center flex-jc-center">
                              <div class="center-td-left">
                                <img :src="jts" alt="">
                              </div>
                              <div class="flex-1">
                                <div class="three-dimensional-small">
                                  <div class="top" />
                                  <div class="flex-al-center">
                                    <div class="left" />
                                    <div class="dimensional-content flex-1">
                                      <sp-radio :disabled="!!companyDetail.id" :value="IDENTITY_BROKER" class="comp-radio">
                                        <p class="font14 radio-label sp-color-4" style="white-space: pre-wrap">{{ $l("Chartering Brokers") }}</p>
                                      </sp-radio>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="center-td-right"><img :src="jts" alt=""></div>
                            </div>
                          </div>
                          <div class="jsl-panel text-center">
                            <img :src="jtl" alt="">
                          </div>
                          <div style="position:relative; top: -10px">
                            <div class="center-td-panel flex-al-center flex-jc-center">
                              <div class="center-td-left">
                                <img :src="jts" alt="">
                              </div>
                              <div class="flex-1">
                                <div class="three-dimensional-small">
                                  <div class="top" />
                                  <div class="flex-al-center">
                                    <div class="left" />
                                    <div class="dimensional-content flex-1">
                                      <sp-radio :disabled="!!companyDetail.id" :value="IDENTITY_OP" :cancelable="false" class="comp-radio">
                                        <p class="font14 radio-label sp-color-4" style="white-space: pre-wrap">{{ $l("Chartering Operators") }}</p>
                                      </sp-radio>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="center-td-right"><img :src="jts" alt=""></div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-32">
                          <div class="three-dimensional">
                            <div class="top" />
                            <div class="flex-al-center">
                              <div class="left" />
                              <div class="dimensional-content flex-1">
                                <sp-radio :value="IDENTITY_SHIP" class="comp-radio" style="margin-top: 0">
                                  <p class="radio-label sp-color-4">{{ $l("Shipowners") }}</p>
                                </sp-radio>
                                <p class="dimensional-content-p">Based on the  background of   actual ownership of  at least one.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </sp-radio-group>
                  </div>
                  <div class="content-right text-left">
                    <sp-radio class="black comp-radio" disabled>
                      <p>{{ $l("Ship Agency ") }}</p>
                    </sp-radio>
                    <sp-radio class="black comp-radio" disabled>
                      <p>{{ $l("Bunker suppliers ") }}</p>
                    </sp-radio>
                    <sp-radio class="black comp-radio" disabled>
                      <p>{{ $l("Ship Repairing ") }}</p>
                    </sp-radio>
                    <sp-radio class="black comp-radio" disabled>
                      <p>{{ $l("Ship Builder") }}</p>
                    </sp-radio>
                    <sp-radio class="black comp-radio" disabled>
                      <p>{{ $l("Shipbrokers（SNP/Shipbulding）") }}</p>
                    </sp-radio>
                    <sp-radio class="black comp-radio" disabled>
                      <p>{{ $l("Ship management") }}</p>
                    </sp-radio>
                  </div>
                </div>
                <div class="bottom text-center">
                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Capt & Shipcrew") }}</p>
                  </sp-radio>
                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Media") }}</p>
                  </sp-radio>
                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Institue") }}</p>
                  </sp-radio>

                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Goverment") }}</p>
                  </sp-radio>
                  <sp-radio class="comp-radio mg-r-20" disabled>
                    <p>{{ $l("Association") }}</p>
                  </sp-radio>
                  <sp-radio class="comp-radio" disabled>
                    <p>{{ $l("Classification") }}</p>
                  </sp-radio>
                </div>
              </div>
            </div>
            <div class="gray-bar" />
            <div class="pd-b-10 pd-l-10 pd-t-10">
              <div class="access-identity">
                <div class="content flex-al-center flex-jc-start">
                  <div class="content-left text-right">
                    <span class="font16 italic-bold sp-color-1">{{ $l('Company Category:') }}</span>
                  </div>
                  <div class="flex-1">
                    <div class="three-dimensional-small">
                      <div class="top" style="width: 98%" />
                      <div class="flex-al-center">
                        <div class="left" />
                        <div class="dimensional-content flex-1">
                          <div class="flex-al-center flex-jc-center pd-t-10">
                            <div style="width: auto; padding-right: 30px">
                              <p class="fw-bold sp-color-7" style="margin: 0">Signing right company</p>
                              <p class="fw-bold sp-color-1" style="margin: 0">【Company that sign contracts (directly bear legal risks)】</p>
                            </div>
                            <div class="flex-1">
                              <sp-radio-group v-model="companyDetail.privSign" name="privSign" :cancelable="false">
                                <sp-radio :disabled="companyDetail.regLevel === '0'" value="1" class="comp-radio mg-r-10">
                                  <p class="radio-label sp-color-11">{{ $l("Yes") }}</p>
                                </sp-radio>
                                <sp-radio value="0" class="comp-radio">
                                  <p class="radio-label sp-color-11">{{ $l("No") }}</p>
                                </sp-radio>
                              </sp-radio-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content-right text-left" />
                </div>
              </div>
            </div>
            <div class="gray-bar" />
            <div class="flex-jc-start pd-l-10 pd-t-20">
              <div class="flex-40">
                <div class="label-content pd-r-20">
                  <p v-if="companyDetail.regLevel==='1' && parseInt(companyDetail.privSign) === 1" class="fw-bold italic label">{{ $l('RegistrationNo') }}</p>
                  <p v-else class="fw-bold italic label">{{ $l('RegistrationNo') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <SpInput v-model="companyDetail.registrationNo" class="flex-1"

                             name="registrationNo" type="warn" />
                    <!--                    :class="{'cus-require': parseInt(companyDetail.privSign)=== 1 && !companyDetail.registrationNo && showVail}" -->
                    <!--                    :cus-error-msg="(parseInt(companyDetail.privSign)=== 1 && !companyDetail.registrationNo && showVail) ? 'require' : null" -->
                  </div>
                </div>
              </div>
              <div class="flex-60">
                <div class="label-content">
                  <p class="italic label sp-color-7">{{ $l('RegisterAddress') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <SpInput v-model="companyDetail.regAddress" class="flex-1" name="regAddress" type="warn3" />
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
              <div class="flex-40">
                <div class="label-content pd-r-20">
                  <!--                  <p v-if="companyDetail.regLevel==='1' && parseInt(companyDetail.privSign) === 1" class="fw-bold italic label">{{ $l('IncorporationDate') }}</p> -->
                  <p class="italic label">{{ $l('IncorporationDate') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <SpDatePicker v-model="companyDetail.incorporationDate" name="incorporationDate"
                                  width="1" type="warn2" placeholder=" " />
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
              <div class="flex-60">
                <div class="label-content">
                  <p class="italic label sp-color-7">{{ $l('Incorporator(separate multiple incorporators with semicolons):') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <SpInput v-model="companyDetail.incorporator" class="flex-1" name="incorporator" type="warn3" />
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
              <div class="flex-100">
                <div class="label-content">
                  <p class="italic label sp-color-7">{{ $l('Assets') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <SpInput v-model="companyDetail.otherAssets" class="flex-1" text-type="textArea" row="3" name="otherAssets" type="warn3" />
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
              <div class="flex-100">
                <div class="label-content">
                  <div class="flex-jc-bt">
                    <span class="italic label sp-color-7" style="position: relative; bottom: -16px">{{ $l('CompanyProfile') }}</span>
                    <div class="flex-1">
                      <div class="content flex-al-center flex-jc-start">
                        <div class="flex-1 pd-r-20 text-right">
                          <span class="italic sp-color-7">{{ $l('Website') }}</span>
                        </div>
                        <div class="flex-1">
                          <SpInput v-model="companyDetail.website" height="34" name="website" type="warn2" />
                        </div>
                        <div class="icon-panel" />
                      </div>
                    </div>
                  </div>
                  <div class="content flex-al-center flex-jc-start" style="margin-top: 0">
                    <el-input v-model="companyDetail.introduction" name="introduction" class="cus-el-input-warn2 flex-1" :placeholder="$l('')"
                              maxlength="2048" type="textarea" show-word-limit :rows="12" />
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>

              <div class="flex-100">
                <div class="label-content">
                  <p class="italic label" style="color:#676767; font-size: 14px;">{{ $l('fixtureWarnTip') }}</p>
                  <div class="content flex-al-center flex-jc-start">
                    <el-input v-model="companyDetail.tradeRemark" name="tradeRemark" class="cus-el-input-warn3 flex-1" :placeholder="$l('FixtureList')"
                              maxlength="2048" type="textarea" show-word-limit :rows="12" />
                    <div class="icon-panel" />
                  </div>
                </div>
              </div>
            </div>
          </sp-card>
        </div>
        <div class="flex-41 pd-l-20 pd-r-20 pd-t-70 right right-side text-left">
          <div class="main">
            <p class="opacity-90">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</p>
            <p class="mg-t-20 opacity-70" style="margin-bottom: 0">{{ $l('CertificateofRegister') }}</p>
            <div class="uploadFile">
              <SpUploadGroup ref="corpCertificate" file-type="corp/certificate"
                             :upload-after-select="!!companyDetail.id"
                             :business-id="companyDetail.id" :default-files="corpCertificateFileList" />
            </div>
            <p class="mg-t-40 opacity-70" style="margin-bottom: 0">{{ $l('Others') }}</p>
            <div class="uploadFile">
              <SpUploadGroup ref="registrationOther" file-type="corp/registration/other"
                             :upload-after-select="!!companyDetail.id" :business-id="companyDetail.id"
                             :default-files="registrationOtherFileList" />
            </div>
          </div>
          <div class="main">
            <p class="mg-t-40 opacity-70" style="margin-bottom: 0">{{ $l('Method1') }}</p>
            <div class="uploadFile">
              <SpUpload
                :default-files="fixtureListFiles"
                file-type="corp/trade/file"
                :upload-after-select="!!companyDetail.id"
                :business-id="companyDetail.id" type="primary" />
            </div>
            <p class="mg-t-40 opacity-70" style="margin-bottom: 0">{{ $l('Method2') }}</p>
            <div class="uploadFile">
              <SpUploadGroup
                ref="tradeRecordPics"
                file-type="corp/trade/pic"
                :upload-after-select="!!companyDetail.id"
                :business-id="companyDetail.id"
                :default-files="tradeRecordPics" />
            </div>
          </div>
        </div>
      </div>
    </SpForm>
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue'
import {
  editEnterpriseCorpApi,
  getEnterpriseCorpDetailApi,
  getEnterpriseStructure,
  updateEnterpriseNodeApi
} from '@/request/APIs/company'
import SpInput from '@/components/common/SpInput'
import spRadio from '@/components/common/SpRadio'
import spRadioGroup from '@/components/common/SpRadioGroup'
import {
  IDENTITY_SHIP, IDENTITY_OP, IDENTITY_BROKER, IDENTITY_CARGO,
  ENTERPRISE_REG_LEVEL_VIRTUAL, ENTERPRISE_REG_LEVEL_REG
} from '@/config/company'
import SpDatePicker from '@/components/common/SpDatePicker'
import { formatFiles } from '@/utils/convert'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpUpload from '@/components/common/SpUpload'
import spCard from '@/components/common/SpCard'
import { isObject } from '@/utils'
import { useRoute, useRouter } from 'vue-router'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import SpForm from '@/components/common/SpForm'
import SpButton from '@/components/common/SpButton'
import { getCountrySpareList, searchAddress } from '@/request/APIs/common'
import _includes from 'lodash/includes'
import SpMessage from '@/components/common/SpMessage'
import { nextTick } from '@vue/runtime-core'

export default {
  name: 'CompanyInfo',
  components: { SpSelectOption, SpSelect, SpUpload, SpUploadGroup, SpDatePicker, SpInput, spRadioGroup, spRadio, spCard, SpForm, SpButton },
  nameSpace: 'company.CompanyDynamics',

  setup (props, ctx) {
    const comInfoForm = ref(null)
    const codeName = computed({
      get () {
        let codeName = companyDetail.value.name ? companyDetail.value.name.toUpperCase().replace(/[\s,\d]*/g, '') : ''
        codeName = codeName.replace(/[^a-zA-Z]/g, '')
        codeName = codeName.length > 15 ? codeName.slice(0, 15) : codeName + new Array(15 - codeName.length < 0 ? 0 : 15 - codeName.length).fill('X').join('')
        return codeName
      },
      set (nv) {
        companyDetail.value.codeName = nv
      }
    })
    const router = useRouter()
    const route = useRoute()
    const nodeEditDisabled = ref(false)
    if (route.query.nodeId) {
      nodeEditDisabled.value = true
    }
    const codeNameDisabled = ref(true)

    const countrys = ref([])
    const citys = ref([])
    if (localStorage.getItem('countrysSpare')) {
      countrys.value = JSON.parse(localStorage.getItem('countrysSpare'))
    } else {
      getCountrySpareList().then((res) => {
        countrys.value = res.data
        localStorage.setItem('countrysSpare', JSON.stringify(res.data))
      })
    }

    const jts = require('@/assets/jts.png')
    const jtl = require('@/assets/jtl.png')
    const companyDetail = ref({
      id: '',
      node: {
        title: ''
      },
      regCountry: {
        name: ''
      },
      regCity: {
        name: ''
      },
      charterers: 1,
      regLevel: '1',
      privSign: '1',
      nodeId: parseInt(route.query.nodeId) || null,
      nodeType: parseInt(route.query.nodeType) || null
    })
    const toSearchCity = (key, needAdd) => {
      searchAddress({ type: 'city', page: 1, cid: companyDetail.value.regCountryId, keyWord: key }).then(res => {
        if (needAdd) {
          if (companyDetail.value.regCity && !_includes(res.data.map(item => item.id), companyDetail.value.regCity.id)) {
            citys.value = [...res.data, companyDetail.value.regCity]
          } else {
            citys.value = res.data
          }
        } else {
          citys.value = res.data
        }
      })
    }
    // 根据国家Id获取城市
    const searchCity = (countryId) => {
      companyDetail.value.regCityId = null
      const selectedCountry = countrys.value.find(c => c.id === countryId)
      companyDetail.value.regCountryCode = selectedCountry.phonecode
      searchAddress({ type: 'city', page: 1, cid: countryId, keyWord: '' }).then(res => {
        citys.value = res.data
      })
    }

    const getDetail = () => {
      if (!route.query.id) return
      nodeEditDisabled.value = true
      getEnterpriseCorpDetailApi(route.query.id).then(res => {
        companyDetail.value = res.data
        companyDetail.value.charterers = 1
        companyDetail.value.companyCategory = 1
        companyDetail.value.incorporationDate = companyDetail.value.incorporationDate === '0000-00-00' ? '' : companyDetail.value.incorporationDate

        companyDetail.value.regLevel = res.data.regLevel + ''
        companyDetail.value.privSign = res.data.privSign + ''

        companyDetail.value.regCountry = res.data.regCountry || { name: '' }
        companyDetail.value.regCity = res.data.regCity || { name: '' }
        companyDetail.value.node = res.data.node || { title: '' }
        companyDetail.value.nodeType = parseInt(route.query.nodeType)

        toSearchCity('', true)
        if (isObject(res.data.marineAssets)) {
          companyDetail.value.marineAssets = ''
        }
      })
    }
    getDetail()
    const linkedOCNodes = ref([])
    const getEnterpriseStructureNodes = () => {
      const random = Math.random().toString()
      getEnterpriseStructure(random).then(res => {
        const arr = [res.data.master, ...res.data.subs]
        linkedOCNodes.value = arr.filter((item) => item.corps.length === 0)
        companyDetail.value.nodeId = parseInt(route.query.nodeId) || null
        companyDetail.value.nodeType = parseInt(route.query.nodeType) || null
        companyDetail.value.node = linkedOCNodes.value.find(i => i.id === parseInt(route.query.nodeId)) || { title: '' }
      })
    }
    // 获取节点信息
    if (!route.query.id) {
      getEnterpriseStructureNodes()
    }

    const corpCertificateFileList = computed(() => {
      return formatFiles(companyDetail.value, 'certificate')
    })

    const registrationOtherFileList = computed(() => {
      return formatFiles(companyDetail.value, 'otherRegistrationFiles')
    })

    const tradeRecordPics = computed(() => {
      return formatFiles(companyDetail.value, 'tradeRecordPics')
    })
    const fixtureListFiles = computed(() => {
      const list = []
      if (companyDetail.value.tradeRecordFiles?.files) {
        const files = companyDetail.value.tradeRecordFiles.files
        Object.keys(files).forEach(key => {
          list.push({
            type: 'img',
            url: files[key],
            id: key,
            name: key
          })
        })
      }
      return list
    })
    const showVail = ref(false)
    const submit = (params) => {
      const result = []
      showVail.value = true
      const vai = params.validate
      // if (parseInt(companyDetail.value.privSign) === 1 && !companyDetail.value.registrationNo) {
      //   vai = false
      // } else {
      //   vai = params.validate
      // }

      if (vai) {
        // 验证通过 调用接口
        if (route.query.id && route.query.type !== 'copy') {
          params.data.id = parseInt(route.query.id) || null
        }

        params.data.introduction = companyDetail.value.introduction || null
        params.data.tradeRemark = companyDetail.value.tradeRemark || null
        params.data.privSign = params.data.privSign ? params.data.privSign : 0
        params.data.nodeId = route.query.nodeId || companyDetail.value.nodeId
        // params.data.privContact = params.data.privContact ? params.data.privContact : 0
        editEnterpriseCorpApi(params.data).then(res => {
          if (!route?.id || route.type === 'copy') {
            companyDetail.value.id = companyDetail.value.id || res.data.id
            router.push({
              name: 'addCompany',
              query: {
                nodeId: companyDetail.value.nodeId,
                nodeType: companyDetail.value.nodeType,
                id: companyDetail.value.id
              }
            })
          }
          if (res.code === 1) {
            SpMessage({
              message: res.message,
              type: 'success'
            })
          }

          // 上传文件
          nextTick(() => {
            params.uploadAllFile().then(() => {

            }).catch(e => {
              SpMessage.error('File upload failed!')
            })
          })
        })
      } else {
        SpMessage({
          message: 'The format of the information entered is incorrect, verification failed, please check',
          type: 'error'
        })
      }
    }
    const nodeChange = (selectedValue, selectItem, selected) => {
      const obj = linkedOCNodes.value.find(a => a.id === selectedValue)
      // console.log(obj)
      companyDetail.value.nodeType = obj.type
      companyDetail.value.node.title = obj.title
      if (obj.type === 2) {
        companyDetail.value.regLevel = '1'
      }
    }
    const oldNodeTitle = ref(null)
    const updateNode = (title) => {
      if (title === oldNodeTitle.value || !title) return
      updateEnterpriseNodeApi(title, companyDetail.value.nodeType || 2, companyDetail.value.nodeId).then(res => {
        companyDetail.value.nodeType = companyDetail.value.nodeType || 2

        if (!route.query.nodeId) {
          companyDetail.value.nodeId = res.data.new.nodes[0].id
          router.push({
            name: 'addCompany',
            query: {
              nodeId: companyDetail.value.nodeId,
              nodeType: 2
            }
          })
        }

        SpMessage({
          message: res.message,
          type: 'success'
        })
      })
    }
    const recordTitle = (title) => {
      oldNodeTitle.value = title
    }
    watch(() => companyDetail.value.regLevel, (nv) => {
      if (parseInt(nv) === 0) {
        companyDetail.value.privSign = '0'
      } else {
        companyDetail.value.privSign = '1'
      }
    })
    watch(() => companyDetail.value.regCountryId, (nv) => {
      if (!nv) {
        companyDetail.value.regCityId = null
      }
    })

    return {
      companyDetail,
      jts,
      jtl,
      corpCertificateFileList,
      registrationOtherFileList,
      tradeRecordPics,
      fixtureListFiles,
      countrys,
      citys,
      linkedOCNodes,
      ENTERPRISE_REG_LEVEL_VIRTUAL,
      ENTERPRISE_REG_LEVEL_REG,
      IDENTITY_SHIP,
      IDENTITY_OP,
      IDENTITY_BROKER,
      IDENTITY_CARGO,
      nodeEditDisabled,
      getEnterpriseStructureNodes,
      submit,
      nodeChange,
      comInfoForm,
      toSearchCity,
      searchCity,
      codeName,
      codeNameDisabled,
      showVail,
      oldNodeTitle,
      updateNode,
      recordTitle,
      route
    }
  }
}
</script>

<style lang="less" scoped>
.company-info{
  .icon-edit-1{
    font-size: 24px;
  }
  .left-side{
    //background-color: #fff;
  }
  .right-side{
    background: #FFFFFF;
  }
  .three-dimensional{
    overflow: hidden;
    .top {
      position: relative;
      left: 18px;
      top: 9px;
      width: 90%;
      height: 16px;
      background-color: #FAFAFA;
      transform: skewX(62deg);
    }
    .left {
      border: none;
      background-color: #ECECEC;
      width: 16px;
      transform: skewY(19deg);
      position: relative;
      height: 116px;
      top: -3px;
    }
    .dimensional-content{
      padding: 12px 20px;
      position: relative;
      margin-right: 0px;
      top: 1px;
      /* left: 2px; */
      height: 116px;
      background-color: rgba(189, 189, 189, 0.5);
      .radio-label{
        font-size: 18px !important;
        color: #FFFFFF !important;
        opacity: 1 !important;
      }
      .dimensional-content-p{
        color: #FFFFFF;
        opacity: 0.5;
      }
    }
  }
  .three-dimensional-small{
    overflow: hidden;
    .top {
      position: relative;
      left: 18px;
      top: 9px;
      width: 90%;
      height: 16px;
      background-color: #FAFAFA;
      transform: skewX(62deg);
    }
    .left {
      border: none;
      background-color: #ECECEC;
      width: 16px;
      transform: skewY(19deg);
      position: relative;
      height: 54px;
      top: -3px;
    }
    .dimensional-content{
      padding: 0px 0 0 6px;
      position: relative;
      margin-right: 0px;
      top: 1px;
      /* left: 2px; */
      height: 54px;
      background-color: rgba(189, 189, 189, 0.5);
      .radio-label{
        font-size: 14px !important;
        opacity: 1 !important;
      }
      .dimensional-content-p{
        color: #FFFFFF;
        opacity: 0.5;
      }
    }
  }
  .center-td-panel{
    .center-td-left {
      text-align: center;
      width: 40px;
      margin-top: 16px;
      img{
        width: 90%;
      }
    }
    .center-td-right{
      text-align: center;
      margin-top: 16px;
      width: 40px;
      img{
        width: 90%;
      }
    }
  }
  .jsl-panel{
    img {
      width: 99%;
    }
  }
  .gray-bar{
    height: 16px;
    background-color: #f6f6f6;
    margin: 0 -30px;
  }
  .comp-radio{
    display: inline-block;
    &.black{
      display: block;
    }
    margin-top: @gap/2;
    p{
      margin: 0;
    }
    .tip{
      font-size: 14px;
    }
  }
  .left{
    //border: 3px #C3DCE0 dashed;
  }
  .label-content{
    margin-bottom: 16px;
    .label{
      margin: 0;
      position: relative;
      z-index: 99;
    }
    .content{
      margin-top: -4px;
    }
    .icon-panel {
      width: 30px;
      text-align: right;
    }
  }
  .access-identity{
    font-size: 14px;
    .content {
      .content-left {
        width: 158px;
      }
      .content-right {
        padding-left: 16px;
        width: 250px;
      }
    }
  }
}
</style>

<style lang="less">
.cus-card-pd > .card-content > .slot[data-v-478faf71] {
  width: 97%;
  padding: 2.5% 0 2.5% 2.5%;
}
.cus-disabled-choose{
  .SpChoose{
    &[disabled='true']{
      label{
        .label{
          opacity: 1;
        }
      }
    }
  }
}
.SpInput{
  &.size-8{
    input {
      text-align: center;
      text-indent: 0;
      font-size: 8px;
    }
  }
}
.cus-el-input-warn2{
  .el-textarea__inner{
    border: none;
    background-color: rgba(254, 212, 126, 0.3);
    box-shadow: none;
    border-radius: 0;
    color: #000;
  }
  .el-textarea__inner:focus {
    border: none;
    outline: none !important;
    box-shadow: none;

  }
}
.cus-el-input-warn3 {
  .el-textarea__inner{
    border: none;
    background-color: rgba(254, 212, 126, 0.1);
    box-shadow: none;
    border-radius: 0;
    color: #000;
  }
  .el-textarea__inner:focus {
    border: none;
    outline: none !important;
    box-shadow: none;
  }
}
.SpSelect{
  &.cus-require {
    border: 1px solid #ff0000 !important;
  }
}
.SpInput{
  &.cus-require {
    border: 1px solid #ff0000 !important;
  }
}
.SpDatePicker{
  &.cus-require {
    border: 1px solid #ff0000 !important;
  }
}
</style>
